/* Du theme — global behaviour: scroll reveal, mobile nav, cart count */
(function () {
  'use strict';

  /* ---- Scroll reveal ---- */
  var reveal = document.querySelectorAll('[data-reveal]');
  if (reveal.length) {
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveal.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () { el.classList.add('is-in'); }, delay);
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      reveal.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- Mobile navigation ---- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('nav-open');
        navToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---- Header state on scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Blob morph on tap (touch devices only) ---- */
  if (window.matchMedia('(pointer: coarse)').matches) {
    document.querySelectorAll('[data-blob-morph]').forEach(function (el) {
      var states = el.getAttribute('data-blob-morph').split('|');
      if (states.length < 2) return;
      var idx = 0;
      el.style.transition = 'border-radius 0.9s cubic-bezier(0.4,0,0.2,1)';
      el.style.cursor = 'pointer';
      el.style.webkitTapHighlightColor = 'transparent';
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        idx = 1 - idx;
        el.style.borderRadius = states[idx].trim();
      });
    });
  }

  /* ---- Live cart count ---- */
  window.duRefreshCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        return cart;
      });
  };

  /* ---- Add-to-cart toast ---- */
  (function () {
    var TOAST_CSS = [
      '#du-toast{',
        'position:fixed;bottom:1.5rem;left:50%;',
        'transform:translateX(-50%) translateY(calc(100% + 2rem));',
        'z-index:9999;',
        'display:flex;align-items:center;gap:0.85rem;',
        'background:var(--ink);color:var(--bg);',
        'padding:0.7rem 0.9rem 0.7rem 1.1rem;',
        'border-radius:999px;',
        'font-size:0.82rem;font-weight:600;',
        'box-shadow:0 8px 32px rgba(0,0,0,0.22);',
        'white-space:nowrap;pointer-events:all;',
        'transition:transform 0.38s cubic-bezier(0.34,1.1,0.64,1),opacity 0.28s ease;',
        'opacity:0;',
      '}',
      '#du-toast.is-visible{',
        'transform:translateX(-50%) translateY(0);opacity:1;',
      '}',
      '#du-toast a{',
        'display:inline-flex;align-items:center;justify-content:center;',
        'padding:0.38rem 1rem;',
        'background:var(--accent);color:#fff;',
        'border-radius:999px;font-size:0.74rem;font-weight:700;',
        'letter-spacing:0.06em;text-transform:uppercase;',
        'text-decoration:none;',
        'transition:background 0.15s;',
        '-webkit-tap-highlight-color:transparent;',
      '}',
      '#du-toast a:hover{background:#0580a0;}'
    ].join('');

    var styleEl = document.createElement('style');
    styleEl.textContent = TOAST_CSS;
    document.head.appendChild(styleEl);

    var toast = document.createElement('div');
    toast.id = 'du-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);

    var hideTimer = null;

    window.duShowToast = function (msg, cartUrl) {
      clearTimeout(hideTimer);
      toast.innerHTML =
        '<span>' + msg + '</span>' +
        '<a href="' + (cartUrl || '/cart') + '">View Cart</a>';
      /* Force reflow so transition fires even on repeat triggers */
      toast.classList.remove('is-visible');
      void toast.offsetWidth;
      toast.classList.add('is-visible');
      hideTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 4000);
    };
  }());
})();
